import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=1f68c231&"
import script from "./CompanyData.vue?vue&type=script&lang=ts&"
export * from "./CompanyData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports